export const makeArtistSlug = (slug: string) => `@${slug}`
export const parseArtistSlug = (slug: string) => slug.replace('@', '')
